export const optionsPieChart = {
    legend: "none",
    vAxis: { minValue: 0 },
    pieSliceText: "label",
    curveType: "function",
}

export const options = {
    legend: 'none',
    chartArea: { width: '80%', height: '80%' },
    hAxis: {
        title: '',
    },
    vAxis: {
        minValue: 0,
    },
    colors: ['#5470c6'],
    bar: { groupWidth: '60%' },
    annotations: {
        alwaysOutside: false,
        stem: {
            length: 0,
        },
        textStyle: {
            fontSize: 15,
            color: '#fff',
            auraColor: 'none',
        },
    },
};
